/* eslint-disable @typescript-eslint/no-explicit-any */

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import { Box } from '@mantine/core';

// Helpers
import {
	capitalizeString,
	getMintStatusLabel,
	getMintStatusType,
} from '@utils/functions';

// Styles
import styles from './CellMintStatus.module.css';
import { MintStatus } from './MintStatus';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const CellMintStatus = (props: { row: any }) => {
	/* ******************************** RENDERING ******************************* */
	return (
		<Box className={styles.cell}>
			<MintStatus
				type={getMintStatusType(
					props.row && props.row.mintStatus
				)}
			>
				{capitalizeString(
					getMintStatusLabel(
						props.row &&
							props.row.mintStatus.toUpperCase()
					)
				)}
			</MintStatus>
		</Box>
	);
};
